<section class="header">
  <h2>Malla societaria</h2>
  <button mat-icon-button (click)="closeDialog()"
  style="position: absolute; right: 10px;">
    <mat-icon>close</mat-icon>
  </button>
</section>
<section class="modal-mesh-main-content" *ngIf="!isLoadingMesh; else loadingMesh">
  <ngx-graph style="height: inherit;"
  [update$]="updateGraph$"
  [curve]="curve"
  [links]="links"
  [nodes]="nodes"
  [layout]="layout"
  [autoCenter]="true"
  [layoutSettings]="layoutSettings"
  [nodeWidth]="170"
  [nodeHeight]="100"
  [enableZoom]="true"
  [autoZoom]="false">
      <ng-template #defsTemplate>
          <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto">
              <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
          </svg:marker>
      </ng-template>

      <ng-template #nodeTemplate let-node>
          <svg:g class="node" xmlns="http://www.w3.org/2000/xhtml" width="170" height="100">
            <svg:foreignObject width="170" height="100">
              <xhtml:div class="cardContainer" xmlns="http://www.w3.org/1999/xhtml" [ngStyle]="getStyles(node)">
                  <div class="entity-content">
                    <label class="name">{{ node.label }}</label>
                    <label>{{ node.data.rut }}</label>    
                  </div>
                  <div class="action">
                    <button (click)="openRelatedNode(node)" mat-icon-button>
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
              </xhtml:div>
            </svg:foreignObject>
          </svg:g>
        </ng-template>
        <ng-template #linkTemplate let-link>
          <svg:g class="edge">
            <svg:path class="line" stroke-width="2" marker-end="url(#arrow)"></svg:path>
            <svg:text class="edge-label" text-anchor="middle">
              <textPath
                class="text-path"
                [attr.href]="'#' + link.id"
                [style.dominant-baseline]="link.dominantBaseline"
                startOffset="50%"
              >
                {{ link.label }}
              </textPath>
            </svg:text>
          </svg:g>
          <svg:g
            class="linkMidpoint"
            *ngIf="link.midPoint"
            [attr.transform]="'translate(' + link.midPoint.x + ',' + link.midPoint.y + ')'"
          >
          </svg:g>
        </ng-template>    
  </ngx-graph>
</section>

<ng-template #loadingMesh>
  <div style="display: flex; justify-content: space-around;">
    <mat-spinner diameter="80"></mat-spinner>
  </div>
</ng-template>